export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AUTH_TENENT_ID}`,
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

export const loginRequest = {
    scopes: [process.env.REACT_APP_AUTH_SP_SCOPE]
}; 